import {ResultType} from '@remix-run/router/dist/utils';
import axios from 'axios';
import React from 'react';
import {BASE_URL} from '../config';
import {fetch} from '../../src/apiFunction';

export const createActivity = async (data) => {
  const payload= JSON.stringify(data);
  const token = localStorage.getItem('token');
  const url = BASE_URL + '/activity/create'
  const type ="post"
  const resp = fetch(url,type,payload,token)
  return resp;
};

export const getActivityById = async (id) => {
  const token = localStorage.getItem('token');
  const url = BASE_URL + '/activity/getActivityById/'+ id
  const type ="get"
  const resp = fetch(url,type,null,token)
  return resp;
};